import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Grid, Typography, Link } from "@material-ui/core";
import { Field } from "formik";

import InputWrapper from "../../../../inputs/InputWrapper";
import {
  getErrorMessage,
  hasError,
} from "../../../../../utils/formValidationUtils";
import { FieldContainer, Row } from "../StyledRow";

const LinkWrapper = styled.div`
  display: flex;
  color: #9ea7ba;
  font-size: 12px;
  flex-direction: row;
  margin-top: 4px;
`;
const StyledLink = styled(props => (
  <Link
    href="#"
    type="button"
    component="button"
    variant={"body2"}
    {...props}
  />
))`
  margin-left: 4px;
  color: #57abff;
  cursor: pointer;
  &:hover {
    text-decoration: none;
  }
`;

const SelectContactRow = ({ input, handleToggleCreateNewContact }) => (
  <Row>
    <Grid item xs={12}>
      <FieldContainer>
        <Field name={input.name}>
          {({ field, form }) => (
            <InputWrapper
              {...input}
              {...field}
              label={input.label}
              hasError={hasError(input.name, form)}
              errorMessage={getErrorMessage(input.name, form)}
            />
          )}
        </Field>
        <LinkWrapper>
          <Typography variant={"inherit"}>{"Can't find it?"}</Typography>
          <StyledLink onClick={handleToggleCreateNewContact}>
            Create a new Contact
          </StyledLink>
        </LinkWrapper>
      </FieldContainer>
    </Grid>
  </Row>
);

SelectContactRow.propTypes = {
  input: PropTypes.object.isRequired,
  handleToggleCreateNewContact: PropTypes.func.isRequired,
};

export default SelectContactRow;
